import { UPSPickUpType } from '../../shared/enum/general-enum';
import { ICustomField } from '../../shared/models/custom-field.interface';

export class ShipUserConfig {
  // default values should be loaded only once.
  DefaultBillToThirdPartyAccountNo = '';
  DefaultBillToThirdPartyCountry = '';
  DefaultBillToThirdPartyZipCode = '';
  DefaultInsuredValue = 0;
  DefaultInvoiceNumber = '';
  DefaultReferenceNumber = '';
  editInsuredValue = false;
  isDirectDeliveryOnly = false;
  isAdultSignature = false;
  isCheckResidential = false;
  isDirectSignature = false;
  isNotifyRecipient = false;
  isNotifySender = false;
  isSendCustomEmailToRecipient = false;
  isThermalLabel = false;
  isPrintHighValue = false;
  isBillToThirdParty = false;
  pickupUPSType: UPSPickUpType = UPSPickUpType.Occasional;

  // a flag to see if the config is set by the API.
  isAPIDriven = false;

  // show* should always be loaded.
  showAddressBook = true;
  showAddToExpressContacts = true;
  showAdultSignature = false;
  showAdultSignatureMessage = false;
  showBillDutiesTaxes = false;
  showBillToAccountSelector = false;
  showBillToThirdParty = false;
  showCheckResidential = true;
  showCod = false;
  showCustomsShippingDetails = false;
  showDirectDeliveryOnly = false;
  showDirectSignature = false;
  showDropOffFedEx = false;
  showDropOffUPS = false;
  showExpressContacts = true;
  showFedExBillTo = false;
  showHoldAtFedexLocation = false;
  showNotify = false;
  showNotifyRecipient = true;
  showPowerOfAttorney = false;
  showReturnLabel = false;
  showSaturdayDelivery = false;
  showSaturdayPickUp = false;
  showSaveInAddressBook = true;
  showSchedulePickUp = false;
  showShipFromLocations = true;
  showThermalPrinter = false;
  showUPSBillTo = false;
  showUseAlreadyScheduledPickUp = false;

  // custom fields
  customFields?: ICustomField[] = [];

  isShipToPostalCodeAware = false;
}
